// extracted by mini-css-extract-plugin
module.exports =  {"resetButton":"ring-global-resetButton","button":"Details__button--h4 ring-global-resetButton","heading":"Details__heading--id","asideButton":"Details__asideButton--GB"};